"use client";

import { useRef, useEffect, useState } from "react";
import Slider, { Settings } from "react-slick";
import Image, { type StaticImageData } from "next/image";
import arrowLeft from "../../lib/carousel/arrow_left.png";
import arrowRight from "../../lib/carousel/arrow_right.png";
const styles = new Proxy({"Wrapper":"Wrapper-01775","Grid":"Grid-01775","CarouselWrap":"CarouselWrap-01775","Card":"Card-01775","IconCircle":"IconCircle-01775","Title":"Title-01775","List":"List-01775","ListWrapper":"ListWrapper-01775","SlideOuter":"SlideOuter-01775","Controls":"Controls-01775","Dots":"Dots-01775","Dot":"Dot-01775","DotActive":"DotActive-01775","ArrowBtn":"ArrowBtn-01775"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
/*import "./IconCardContentSlider.scss";*/
import { SerializedEditorState } from "@payloadcms/richtext-lexical/lexical";
import { RichText } from "payload-pms/RichText";

interface CarouselCard {
  title: string;
  image: StaticImageData | { url: string };
  content: SerializedEditorState;
}

export default function IconCardBulletpointsCarousel({
  cards,
}: {
  cards: CarouselCard[];
}) {
  const sliderRef = useRef<Slider>(null);
  const [active, setActive] = useState(false);
  const [slidesToShow, setSlidesToShow] = useState(2);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const check = () => {
      const w = window.innerWidth;
      setActive(w < 1200);
      setSlidesToShow(w < 768 ? 1 : 2);
    };
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  if (!active) return null;

  const dotCount = cards.length;

  const SETTINGS: Settings = {
    dots: false,
    arrows: false,
    slidesToShow,
    slidesToScroll: 1,
    infinite: true,
    swipeToSlide: true,
    speed: 300,
    cssEase: "ease",
    afterChange: (index) => setCurrent(index),
  };

  return (
    <div className={styles.CarouselWrap}>
      <Slider
        ref={sliderRef}
        {...SETTINGS}
        className="IconCardBulletpointsSlider"
      >
        {cards.map((card, idx) => (
          <div key={idx} className={styles.SlideOuter}>
            <div className={styles.Card} style={{ height: "100%" }}>
              <div className={styles.IconCircle}>
                <Image
                  src={"url" in card.image ? card.image.url : card.image}
                  width={132}
                  height={124}
                  alt={card.title}
                />
              </div>
              <h4 className={styles.Title}>{card.title}</h4>
              <div className={styles.ListWrapper}>
                {card.content && <RichText content={card.content} />}
              </div>
            </div>
          </div>
        ))}
      </Slider>
      <div className={styles.Controls}>
        <button
          className={styles.ArrowBtn}
          onClick={() => sliderRef.current?.slickPrev()}
          aria-label="Previous"
        >
          <Image src={arrowLeft} alt="Previous" width={20} height={29} />
        </button>
        <ul className={styles.Dots}>
          {Array.from({ length: dotCount }).map((_, i) => (
            <li
              key={i}
              className={
                i === current % dotCount ? styles.DotActive : styles.Dot
              }
              onClick={() => sliderRef.current?.slickGoTo(i)}
            />
          ))}
        </ul>
        <button
          className={styles.ArrowBtn}
          onClick={() => sliderRef.current?.slickNext()}
          aria-label="Next"
        >
          <Image src={arrowRight} alt="Next" width={20} height={29} />
        </button>
      </div>
    </div>
  );
}
